import { useContext, useState, useMemo, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import BasicSurveySecondController from '../../controllers/aia/BasicSurveySecondController';
import ButtonPrint from '../../components/buttonComponents/ButtonPrint';

const BasicSurveySecond = () => {
  useEffect(() => {
    document.title = '유해요인 및 평가';
  }, []);

  const contentRef = useRef(null);

  const location = useLocation();
  const [pageParam, setPageParam] = useState(location.state?.rowData);

  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const naviagte = useNavigate();

  const [mode, setMode] = useState('');
  const [rskList, setRskList] = useState([]);

  const controller = useMemo(() => {
    return new BasicSurveySecondController(
      { store, updateStore },
      { pageParam, setPageParam },
      { mode, setMode },
      { rskList, setRskList },
      modalService,
      validateService,
      naviagte
    );
  }, [store, modalService, validateService]);

  useEffect(() => {
    if (
      pageParam !== undefined &&
      pageParam !== null &&
      pageParam?.bscExmnId !== undefined &&
      pageParam?.bscExmnId !== null &&
      pageParam?.bscExmnId !== '' &&
      pageParam?.anlsAplyId !== undefined &&
      pageParam?.anlsAplyId !== null &&
      pageParam?.anlsAplyId !== ''
    ) {
      controller.fnSearch();
    }
  }, [pageParam]);

  useEffect(() => {
    setPageParam({
      entSn: location.state?.entSn,
      aiaAplyId: location.state?.aiaAplyId,
      anlsAplyId: location.state?.anlsAplyId,
      bscExmnId: location.state?.bscExmnId,
      entSn: location.state?.entSn,
    });
  }, [location]);

  const imgRefs = useRef([]);
  const textareaRefs1 = useRef([]);
  const textareaRefs2 = useRef([]);

  const handleImageLoad = index => {
    if (
      imgRefs.current[index] &&
      textareaRefs1.current[index] &&
      textareaRefs2.current[index]
    ) {
      const imgHeight = imgRefs.current[index].clientHeight;
      textareaRefs1.current[index].style.height = `${imgHeight}px`;
      textareaRefs2.current[index].style.height = `${imgHeight}px`;

      // 너비를 고정
      textareaRefs1.current[index].style.width = '100%';
      textareaRefs2.current[index].style.width = '100%';
    }
  };

  return (
    <>
      <div ref={contentRef}>
        <div className="page-title-wrap" data-type="responsive">
          <h2 className="h-tit">유해요인조사관리 - 유해요인 기본조사표</h2>
        </div>
        <div className="tbl-wrap">
          <h3 className="block-tit">유해요인 및 평가</h3>
          <table className="tbl data col">
            <colgroup>
              <col style={{ width: '30%' }} />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" style={{ width: '30%' }}>
                  대표이미지
                </th>
                <th scope="col">유해요인</th>
                <th scope="col">발생원인</th>
              </tr>
            </thead>
            <tbody>
              {rskList !== undefined &&
                rskList !== null &&
                rskList.length > 0 &&
                rskList.map((rsk, index) => {
                  return (
                    <>
                      <tr>
                        <td className="bg1">
                          <div
                            className="img-item"
                            style={{
                              position: 'relative',
                              display: 'inline-block',
                            }}
                          >
                            <img
                              ref={el => (imgRefs.current[index] = el)}
                              src={rsk?.thmbDp}
                              alt="Main Display"
                              onLoad={() => handleImageLoad(index)}
                            />
                            <span
                              style={{
                                position: 'absolute',
                                bottom: '10px',
                                right: '10px',
                                padding: '6px 10px',
                                backgroundColor: '#f0f0f0',
                                borderRadius: '8px',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                fontSize: '12px',
                              }}
                            >{`${rsk?.anlsTrprLbl}`}</span>
                          </div>
                        </td>
                        <td>
                          <div className="input-group">
                            <label
                              className="hidden-label"
                              htmlFor={`${rsk.frameNo}${rsk.anlsTrprLbl}rskVrbl`}
                              id={`${rsk.frameNo}${rsk.anlsTrprLbl}rskVrbl`}
                            >
                              라벨
                            </label>
                            <textarea
                              ref={el => (textareaRefs1.current[index] = el)}
                              style={{ whiteSpace: 'pre-wrap' }}
                              type="text"
                              id={`${rsk.frameNo}${rsk.anlsTrprLbl}rskVrbl`}
                              className="form-control md"
                              placeholder="유해요인에 대한 설명"
                              onChange={e => {
                                controller.fnChangeRisk(
                                  rsk?.rskId,
                                  rsk?.aiaRsltId,
                                  rsk.frameNo,
                                  rsk.anlsTrprLbl,
                                  'rskVrbl',
                                  e.target.value
                                );
                              }}
                              value={rsk?.rskVrbl}
                              maxLength={100}
                              aria-labelledby={`${rsk.frameNo}${rsk.anlsTrprLbl}rskVrbl`}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="input-group">
                            <label
                              className="hidden-label"
                              htmlFor={`${rsk.frameNo}${rsk.anlsTrprLbl}rskVrblCs`}
                              id={`${rsk.frameNo}${rsk.anlsTrprLbl}rskVrblCs`}
                            >
                              라벨
                            </label>
                            <textarea
                              ref={el => (textareaRefs2.current[index] = el)}
                              type="text"
                              id={`${rsk.frameNo}${rsk.anlsTrprLbl}rskVrblCs`}
                              className="form-control md"
                              placeholder="발생원인 설명"
                              onChange={e => {
                                controller.fnChangeRisk(
                                  rsk?.rskId,
                                  rsk?.aiaRsltId,
                                  rsk.frameNo,
                                  rsk.anlsTrprLbl,
                                  'rskVrblCs',
                                  e.target.value
                                );
                              }}
                              value={rsk?.rskVrblCs}
                              maxLength={333}
                              aria-labelledby={`${rsk.frameNo}${rsk.anlsTrprLbl}rskVrblCs`}
                            />
                          </div>
                        </td>
                      </tr>
                    </>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="page-btn-wrap both">
        <button
          type="button"
          className="btn xlg tertiary"
          onClick={() => {
            controller.fnGoToPrevPage();
          }}
        >
          이전
        </button>
        <div className="btn-group">
          <ButtonPrint buttonName="인쇄" printRef={contentRef} />
          <button
            type="button"
            className="btn xlg primary"
            onClick={() => {
              controller.fnSave();
            }}
          >
            저장
          </button>
        </div>
      </div>
    </>
  );
};

export default BasicSurveySecond;
